import React from "react";
import * as Icon from "react-feather";
import WComponent from "../../../../../../../common/WComponent";

class AJEProposal extends WComponent {
	state = { added: false };

	render() {
	let { proposal, depreciationRate, onRateChange, onApprove, onEdit } = this.props;
	let { added } = this.state;
	let hasRateCalc = proposal.grossPPE != null && proposal.defaultRate != null;
	let amount = hasRateCalc ? Math.round(proposal.grossPPE * depreciationRate / 100) : proposal.amount;

	if (added) {
		return (
			<div className="afs-review__exec-proposal afs-review__exec-proposal--done">
				<Icon.CheckCircle size={14} color="#2e7d32" />
				<span className="afs-review__exec-proposal-confirmed">Entry added — DR {proposal.debitDescription} / CR {proposal.creditDescription} ${amount.toLocaleString("en-CA")}</span>
			</div>
		);
	}

	return (
		<div className="afs-review__exec-proposal">
			{hasRateCalc && (
				<div className="afs-review__exec-proposal-calc">
					<span>{"$" + proposal.grossPPE.toLocaleString("en-CA") + " gross PP&E × "}</span>
					<input
						type="number"
						className="afs-review__exec-proposal-rate-input"
						value={depreciationRate}
						min={1}
						max={100}
						onChange={(e) => { onRateChange(parseFloat(e.target.value) || 0); }}
					/>
					<span>{"% = $" + amount.toLocaleString("en-CA")}</span>
				</div>
			)}
			<div className="afs-review__exec-proposal-entry">
				<div className="afs-review__exec-proposal-line">
					<span className="afs-review__exec-proposal-side">DR</span>
					<span>{proposal.debitDescription}</span>
					<span className="afs-review__exec-proposal-gifi">{"GIFI " + proposal.debitGifi}</span>
					<span className="afs-review__exec-proposal-amount">{"$" + amount.toLocaleString("en-CA")}</span>
				</div>
				<div className="afs-review__exec-proposal-line">
					<span className="afs-review__exec-proposal-side">CR</span>
					<span>{proposal.creditDescription}</span>
					<span className="afs-review__exec-proposal-gifi">{"GIFI " + proposal.creditGifi}</span>
					<span className="afs-review__exec-proposal-amount">{"$" + amount.toLocaleString("en-CA")}</span>
				</div>
			</div>
			<div className="afs-review__exec-proposal-actions">
				{onEdit && (
					<button className="afs-review__exec-proposal-edit" onClick={() => onEdit(amount)} title="Open in the full AJE editor to add/change lines before approving">
						<Icon.Edit3 size={14} /> Edit
					</button>
				)}
				<button className="afs-review__exec-proposal-approve" onClick={() => {
					if (onApprove) onApprove(amount);
					this.update({ added: true });
				}}>
					<Icon.Check size={14} /> Add Entry
				</button>
			</div>
		</div>
	);
	}
}

export default AJEProposal;
